<template>
  <div>
    <div><span @click="gotoChangePassword('personalInfo')">个人信息</span><span>></span><span>更改密码</span></div>
    <div class="login">
      <div class="center_box t-10">
        <div class="login_min mt0">
          <vue-form :state="formstate" id="loginForm">
            <validate tag="div" class="p_rel">
              <p>旧密码</p>
              <input class="pass_word" id="user_name" v-model="params.pre_password" type="text" name="pre_password" placeholder="" required pattern="^\d{6}$">
              <field-messages name="pre_password" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">旧密码不能为空</div>
                <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
              </field-messages>
            </validate>
            <validate tag="div" class="p_rel">
              <p>新密码</p>
              <input class="pass_word" id="" v-model="params.new_password" type="text" name="new_password" placeholder="" required pattern="^\d{6}$">
              <field-messages name="new_password" show="$dirty || $touched || $submitted">
                <div slot="required" class="errorMessage">旧密码不能为空</div>
                <div slot="pattern" class="errorMessage">请填写6位数字密码</div>
              </field-messages>
            </validate>
            <div>
              <button :class="{can_login:disabled==true}" @click.prevent="toChangePassword" id="login" type="" :disabled="!disabled">完成</button>
            </div>
          </vue-form>
        </div>
      </div>
      <toastTips :content="toastContent" :is-show="toast"></toastTips>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import toastTips from '../../components/layer/toastTips'
  export default {
    name: 'changePassword',
    data () {
      return {
        formstate:{},
        disabled:false,
        toast:false,
        toastContent:'',
        params:{
          pre_password:'',
          new_password:''
        }
      }
    },
    components:{
      toastTips
    },
    methods:{
      toChangePassword:function(){
        axios.post('/admin/updatePassword ',qs.stringify(
          this.params
        )).then((response)=>{
          if(response.data.code==22000){
            window.location.href='/#/login'
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      gotoChangePassword:function(changItem){
        this.$emit('changePassWord',changItem);
      },
    },
    watch:{
      'formstate.$invalid':function(){
        if(!this.formstate.$invalid){
          this.disabled=true;
        }else{
          this.disabled=false;
        }

      }
    }
  }
</script>
<style lang="less">
  .l-h70{
    line-height: 70px;
  }
  .login_min{
  div{
    margin-top: 10px;
  p{
    line-height: 40px;
    font-size: 16px;
  }
  }
  }
  .t80{
    top:80px!important;
  }
  .t-10{
    top: 10%!important;
    margin-top: 0!important;
  }
  .p_rel{
    position: relative !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal_center/changePassword.vue